module.exports = __webpack_public_path__ + "static/img/8.0e2a039.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/8.png
// module id = 5PMd
// module chunks = 0